import React from 'react';
import { useLocation } from 'react-router-dom';
import LeadForm from "./LeadForm";


const AddLeadForm = () => {
      const location = useLocation();
      const leadData = location.state?.leadData;
      return <LeadForm isEditMode={true} initialData={leadData} />;
}

export default AddLeadForm;